import request from '@/utils/request'


export function GetBranchMeals(branchId) {
    return request({
        url: '/Meal/GetBranchMeals',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function GetBranchActiveMeals(branchId) {
    return request({
        url: '/Meal/GetBranchActiveMeals',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function SaveMeal(id, branchId, name, startTime, endTime, hbReserve, hbCancel, sort, isActive) {
    return request({
        url: '/Meal/Save',
        method: 'post',
        data: {
            Id: id,
            BranchId: parseInt(branchId),
            StartTime: startTime,
            EndTime: endTime,
            HbReserve: hbReserve,
            HbCancel: hbCancel,
            Sort: sort,
            Name: name,
            IsActive: isActive
        }

    })
}

export function DeleteMeal(id) {
    return request({
        url: '/Meal/Delete',
        method: 'post',
        data: {
            Id: id,

        }

    })
}